import React from 'react';
import './styles.scss';
import { Button } from 'antd';

const Navigation = ({
  isDisabledNext,
  handleNext,
  handleReset,
  isReset = false,
  handleBack,
  isBack = false,
  resetText = '',
  nexttext = '',
  isSHowMessage = false
}) => {
  return (
    <div className="navigation">
      <Button
        onClick={handleNext}
        disabled={isDisabledNext && !isSHowMessage}
        type="primary"
        size="large"
        style={{ minWidth: 186 }}
      >
        {nexttext != '' ? nexttext : 'Next'}
      </Button>
      {isBack && (
        <Button onClick={handleBack} size="large" style={{ minWidth: 186 }}>
          Back
        </Button>
      )}
      {isReset && (
        <Button onClick={handleReset} size="large" style={{ minWidth: 186 }}>
          {resetText != '' ? resetText : 'Reset'}
        </Button>
      )}
    </div>
  );
};

export default Navigation;
